import { Box, Link, Typography } from '@mui/material'

interface Props {
  accept?: string
  selectFile: (selectedFile: File | undefined) => void
}

export const DragAndDropFilePicker = (props: Props): JSX.Element => {
  const handleDropFile = (e: React.DragEvent<HTMLDivElement>): void => {
    e.preventDefault()
    e.stopPropagation()

    const selectedFile = e.dataTransfer.files?.[0]

    props.selectFile(selectedFile)
  }

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const selectedFile = e.target.files?.[0]

    props.selectFile(selectedFile)
  }

  const clearFile = (e: React.MouseEvent<HTMLInputElement>): void => {
    e.currentTarget.value = ''
    props.selectFile(undefined)
  }

  return <Box
    data-testid='filePickerDropArea'
    onDrop={handleDropFile}
    onDragOver={(e) => { e.preventDefault() }}
    sx={{
      border: '2px dashed #E1E1E2',
      borderRadius: '0',
      bgcolor: '#FCFCFC',
      p: '32px',
      justifyItems: 'center',
      width: 'inherit',
      textTransform: 'none',
      display: 'block',
      cursor: 'default',
      color: 'black'
    }}
  >
    <Typography variant='body1'>
      Drag and drop your file here
    </Typography>

    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant='body1'>
        or
      </Typography>

      <Link component='label' sx={{ ml: '.25em', cursor: 'pointer' }}>
        <Typography variant='body1' sx={{ color: 'var(--blue-500)' }}>upload here.</Typography>
        <input hidden type='file' name='file' accept={props.accept} onChange={handleFileSelect} onClick={clearFile} data-testid='filePickerInput' />
      </Link>
    </Box>
  </Box>
}
